import { doLogout } from "actions/authAction";
import { BASE_URL } from "../actions/constant";

export const MASTER_HARGA_GET_LOADING = "MASTER_HARGA_GET_LOADING";
export const MASTER_HARGA_GET_ERROR = "MASTER_HARGA_GET_ERROR";
export const MASTER_HARGA_GET_SUCCESS = "MASTER_HARGA_GET_SUCCESS";
export const FORM_MASTER_HARGA = "FROM_MASTER_HARGA";
export const FORM_MASTER_HARGA_MULTI = "FORM_MASTER_HARGA_MULTI";
export const FORM_MASTER_HARGA_MULTI_DELETE = "FORM_MASTER_HARGA_MULTI_DELETE";
export const GET_MASTER_HARGA_DETAIL = "GET_MASTER_HARGA_DETAIL";
export const FORM_MASTER_HARGA_MULTI_EDIT = "FORM_MASTER_HARGA_MULTI_EDIT";
export const FORM_MASTER_HARGA_EDIT_PER_CONTAINER =
  "FORM_MASTER_HARGA_EDIT_PER_CONTAINER";

export const GET_ACTIVE_MASTER_HARGA = "GET_ACTIVE_MASTER_HARGA";

const masterHargaGetLoading = (bool) => {
  return {
    type: MASTER_HARGA_GET_LOADING,
    getLoading: bool,
  };
};

const masterHargaGetError = (bool) => {
  return {
    type: MASTER_HARGA_GET_ERROR,
    getError: bool,
  };
};

const masterHargaGetSuccess = (bool, dataMasterHarga) => {
  return {
    type: MASTER_HARGA_GET_SUCCESS,
    getSuccess: bool,
    dataMasterHarga,
  };
};

const masterHargaForm = (bool, code, status, data, message) => {
  return {
    type: FORM_MASTER_HARGA,
    code: code,
    open: bool,
    status: status,
    data,
    message: message,
  };
};

const masterHargaFormMulti = (loading, success, error, data, message) => {
  return {
    type: FORM_MASTER_HARGA_MULTI,
    loading: loading,
    success: success,
    error: error,
    data: data,
    message: message,
  };
};

const masterHargaFormMultiEdit = (loading, success, error, data, message) => {
  return {
    type: FORM_MASTER_HARGA_MULTI_EDIT,
    loading: loading,
    success: success,
    error: error,
    data: data,
    message: message,
  };
};

const masterHargaFormEditPerContainer = (
  loading,
  success,
  error,
  data,
  message
) => {
  return {
    type: FORM_MASTER_HARGA_EDIT_PER_CONTAINER,
    loading: loading,
    success: success,
    error: error,
    data: data,
    message: message,
  };
};

const masterHargaDeleteMulti = (loading, success, error, data, message) => {
  return {
    type: FORM_MASTER_HARGA_MULTI_DELETE,
    loading: loading,
    success: success,
    error: error,
    data: data,
    message: message,
  };
};

const getMasterHarga = (loading, success, error, data, message) => {
  return {
    type: GET_MASTER_HARGA_DETAIL,
    loading: loading,
    success: success,
    error: error,
    data: data,
    message: message,
  };
};

const getActiveMasterHarga = (bool, code, data) => {
  // code status 0 = proccess, 1 = success, 2 = error
  return {
    type: GET_ACTIVE_MASTER_HARGA,
    loading: bool,
    code: code,
    data: data,
  };
};

export function masterHargaActionForm(open, code, status, data, message) {
  return (dispatch) => {
    dispatch(masterHargaForm(open, code, status, data, message));
  };
}

export function masterHargaGetData(params) {
  // params ? (params = params) : (params = { page: 1, sizePerPage: 5 });
  if (!params) {
    params = { page: 1, sizePerPage: 5 };
  }
  return (dispatch) => {
    dispatch(masterHargaGetLoading(true));
    dispatch(masterHargaGetError(false));
    dispatch(masterHargaGetSuccess(false, null));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    const { page, sizePerPage } = params;
    let urlParams = `?page=${page}&limit=${sizePerPage}`;
    if (params.tahun) {
      urlParams = urlParams + `&tahun=${params.tahun}`;
    }
    if (params.status) {
      urlParams = urlParams + `&status=${params.status}`;
    }
    if (params.idTrayek) {
      urlParams = urlParams + `&trayek=${params.idTrayek}`;
    }

    if (params.ruas) {
      urlParams = urlParams + `&ruas=${params.ruas}`;
    }

    fetch(BASE_URL + "master_harga/" + urlParams, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        dispatch(masterHargaGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 400) {
          dispatch(masterHargaGetError(true));
        } else {
          // dispatch(masterHargaGetActive());
          dispatch(masterHargaGetSuccess(true, data.data));
        }
      })
      .catch((err) => {
        dispatch(masterHargaGetError(true));
      });
  };
}

export function saveData(params) {
  return (dispatch) => {
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    let urlRequest = BASE_URL + "master_harga/";
    let status;

    if (params.isDelete) {
      urlRequest = urlRequest + params.fId;
      config = {
        method: "DELETE",
        body: JSON.stringify({
          id: params.fId,
          keterangan: params.fKeterangan,
        }),
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      status = "hapus";
    } else {
      if (params.fId !== 0) {
        urlRequest = urlRequest + params.fId;
        config = {
          method: "POST",
          body: JSON.stringify({
            tarif_dry: parseFloat(params.fDry),
            tarif_reefer: parseFloat(params.fReefer),
            lcl_dry_25: parseFloat(params.fDry25),
            lcl_reefer_25: parseFloat(params.fReefer25),
            lcl_dry_50: parseFloat(params.fDry50),
            lcl_reefer_50: parseFloat(params.fReefer50),
            lcl_dry_75: parseFloat(params.fDry75),
            lcl_reefer_75: parseFloat(params.fReefer75),
            tarif_curah: parseFloat(params.fCurah),
            tarif_box: parseFloat(params.fBox),
            tarif_referensi: params.fReferensi,
            tarif_tahun: parseFloat(params.fTahun),
            tarif_status: params.fStatus,
            id_mst_kode_trayek: parseFloat(params.kode),
            id_size_container: parseFloat(params.sizeContainer),
            keterangan: params.fKeterangan,
            // status: 0
          }),
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
        status = "edit";
      } else {
        config = {
          method: "POST",
          body: JSON.stringify({
            tarif_dry: parseFloat(params.fDry),
            tarif_reefer: parseFloat(params.fReefer),
            lcl_dry_25: parseFloat(params.fDry25),
            lcl_reefer_25: parseFloat(params.fReefer25),
            lcl_dry_50: parseFloat(params.fDry50),
            lcl_reefer_50: parseFloat(params.fReefer50),
            lcl_dry_75: parseFloat(params.fDry75),
            lcl_reefer_75: parseFloat(params.fReefer75),
            tarif_curah: parseFloat(params.fCurah),
            tarif_box: parseFloat(params.fBox),
            tarif_referensi: params.fReferensi,
            tarif_tahun: parseFloat(params.fTahun),
            tarif_status: params.fStatus,
            created_by: localStorage.getItem("tolaut@userId"),
            id_mst_kode_trayek: parseFloat(params.kode),
            id_size_container: parseFloat(params.sizeContainer),
          }),
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
        status = "add";
      }
    }

    fetch(urlRequest, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        // dispatch(masterHargaForm(true, 1, '', []))
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 400) {
          dispatch(masterHargaForm(true, 0, status, params, data.message));
        } else {
          dispatch(masterHargaForm(false, 1, "", [], data.message));
          dispatch(masterHargaGetData());
        }
      })
      .catch((err) => {
        dispatch(masterHargaForm(true, 0, status, params));
      });
  };
}

export function saveDataMulti(params) {
  return (dispatch) => {
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    let urlRequest = BASE_URL + "master_harga";
    // let status;

    if (params.status_form === "save") {
      delete params["status_form"];
      config = {
        method: "POST",
        body: JSON.stringify({
          ...params,
          created_by: localStorage.getItem("tolaut@userId"),
        }),
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };

      // status = "add";
    }

    dispatch(masterHargaFormMulti(true, false, false, null, ""));
    fetch(urlRequest, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 400) {
          dispatch(
            masterHargaFormMulti(false, false, true, null, data.message)
          );
        } else {
          dispatch(
            masterHargaFormMulti(false, true, false, data.data, data.message)
          );
          // dispatch(masterHargaGetData());
        }
      })
      .catch((err) => {
        dispatch(masterHargaFormMulti(false, true, false, null, "Error"));
      });
  };
}

export function editDataMulti(params) {
  return (dispatch) => {
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    let urlRequest = BASE_URL + "master_harga/update-multi";
    // let status;

    config = {
      method: "POST",
      body: JSON.stringify({
        ...params,
        // created_by: localStorage.getItem("tolaut@userId"),
      }),
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    dispatch(masterHargaFormMultiEdit(true, false, false, null, ""));
    fetch(urlRequest, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 400) {
          dispatch(
            masterHargaFormMultiEdit(false, false, true, null, data.message)
          );
        } else {
          dispatch(
            masterHargaFormMultiEdit(
              false,
              true,
              false,
              data.data,
              data.message
            )
          );
          // dispatch(masterHargaGetData());
        }
      })
      .catch((err) => {
        dispatch(masterHargaFormMultiEdit(false, true, false, null, "Error"));
      });
  };
}

export function editDataPerContainer(params) {
  return (dispatch) => {
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    let urlRequest = BASE_URL + "master_harga/update";
    // let status;

    config = {
      method: "POST",
      body: JSON.stringify({
        ...params,
        // created_by: localStorage.getItem("tolaut@userId"),
      }),
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    dispatch(masterHargaFormEditPerContainer(true, false, false, null, ""));
    fetch(urlRequest, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 400) {
          dispatch(
            masterHargaFormEditPerContainer(
              false,
              false,
              true,
              null,
              data.message
            )
          );
        } else {
          dispatch(
            masterHargaFormEditPerContainer(
              false,
              true,
              false,
              data.data,
              data.message
            )
          );
          // dispatch(masterHargaGetData());
        }
      })
      .catch((err) => {
        dispatch(
          masterHargaFormEditPerContainer(false, true, false, null, "Error")
        );
      });
  };
}

export function deleteDataMulti(params) {
  return (dispatch) => {
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    let urlRequest = BASE_URL + "master_harga/";
    // let status;

    config = {
      method: "DELETE",
      body: JSON.stringify({
        id: params.id,
        keterangan: params.keterangan,
      }),
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    dispatch(masterHargaDeleteMulti(true, false, false, null, ""));
    fetch(urlRequest, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 400) {
          dispatch(
            masterHargaDeleteMulti(false, false, true, null, data.message)
          );
        } else {
          dispatch(
            masterHargaDeleteMulti(false, true, false, data.data, data.message)
          );
          // dispatch(masterHargaGetData());
        }
      })
      .catch((err) => {
        dispatch(masterHargaDeleteMulti(false, true, false, null, "Error"));
      });
  };
}

export function getmasterHargaDetail(params) {
  return (dispatch) => {
    dispatch(getMasterHarga(true, false, false, null, ""));
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        trayek: params.trayek,
        tahun: params.tahun,
      }),
    };

    fetch(BASE_URL + "master_harga/get", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        // dispatch(getMasterHarga(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 400) {
          dispatch(getMasterHarga(false, false, true, data.data, data.message));
        } else {
          dispatch(getMasterHarga(false, true, false, data.data, data.message));
          // dispatch(masterHargaGetData());
        }
      })
      .catch((err) => {
        dispatch(masterHargaFormMulti(false, true, false, null, "Error"));
      });
  };
}

export function masterHargaGetActive(params) {
  return (dispatch) => {
    dispatch(getActiveMasterHarga(false, 0, []));
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    let urlParams = `?page=1&limit=1`;

    if (params.tahun) {
      urlParams = urlParams + `&tahun=${params.tahun}`;
    }
    if (params.status) {
      urlParams = urlParams + `&status=${params.status}`;
    }
    if (params.kodeTrayek) {
      urlParams = urlParams + `&idTrayek=${params.kodeTrayek}`;
    }

    fetch(BASE_URL + "master_harga" + urlParams, config)
      .then((response) => {
        dispatch(getActiveMasterHarga(true, 0, []));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 400) {
          dispatch(getActiveMasterHarga(false, 1, []));
        } else {
          dispatch(getActiveMasterHarga(false, 1, data.data));
        }
      })
      .catch((err) => {
        dispatch(getActiveMasterHarga(false, 2, []));
      });
  };
}
